import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Download({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Download</title>
      <path
        d="M19.75 15C19.75 14.5858 19.4142 14.25 19 14.25C18.5858 14.25 18.25 14.5858 18.25 15H19.75ZM5.75 15C5.75 14.5858 5.41421 14.25 5 14.25C4.58579 14.25 4.25 14.5858 4.25 15H5.75ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM12 15L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L12 15ZM10.5303 12.4697C10.2374 12.1768 9.76256 12.1768 9.46967 12.4697C9.17678 12.7626 9.17678 13.2374 9.46967 13.5303L10.5303 12.4697ZM14.5303 13.5303C14.8232 13.2374 14.8232 12.7626 14.5303 12.4697C14.2374 12.1768 13.7626 12.1768 13.4697 12.4697L14.5303 13.5303ZM17 18.25H7V19.75H17V18.25ZM19.75 17V15H18.25V17H19.75ZM5.75 17V15H4.25V17H5.75ZM7 18.25C6.30964 18.25 5.75 17.6904 5.75 17H4.25C4.25 18.5188 5.48122 19.75 7 19.75V18.25ZM17 19.75C18.5188 19.75 19.75 18.5188 19.75 17H18.25C18.25 17.6904 17.6904 18.25 17 18.25V19.75ZM11.25 5V15H12.75V5H11.25ZM12.5303 14.4697L10.5303 12.4697L9.46967 13.5303L11.4697 15.5303L12.5303 14.4697ZM12.5303 15.5303L14.5303 13.5303L13.4697 12.4697L11.4697 14.4697L12.5303 15.5303Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
